import React from "react";
import { Tooltip, Marker } from "react-leaflet";
import { Popup } from "react-leaflet";
import L from "leaflet";

import { API_CONFIG, MAP_MARKER_TYPES } from "common/config";
import { LABELS } from "common/labels";

const markerImg = require("./images/vehicle.png");
const radarImg = require("./images/shop_32x32.png");
const severeDelay = require("./images/redMarker.png");
const moderateDelay = require("./images/marker-gopal.png");
const regularDelay = require("./images/shop.png");

const MapMarkers = (props: any) => {
  const {
    showMarkers,
    tripDelivery,
    showParking,
    showLabels,
    points,
    markerType,
  } = props;

  const getMapMarker = ({ vehicleId }, type = MAP_MARKER_TYPES["NORMAL"]) => {
    let iconUrl: any = markerImg;
    switch (type) {
      case MAP_MARKER_TYPES["RADAR"]:
        iconUrl = radarImg;
        break;
      case MAP_MARKER_TYPES["SEVERE_DELAY"]:
        iconUrl = severeDelay;
        break;
      case MAP_MARKER_TYPES["MODERATE_DELAY"]:
        iconUrl = moderateDelay;
        break;
      case MAP_MARKER_TYPES["REGULAR_DELAY"]:
        iconUrl = regularDelay;
        break;
      default:
        break;
    }
    let customMarker: any = null;
    let width = 26;
    let angle = 0;

    const html =
      "<div class='marker' id='marker-" +
      vehicleId +
      "' style='transform: rotate(" +
      angle.toString() +
      "deg);'><img src='" +
      iconUrl +
      "' alt='' width='" +
      width +
      "px'/></div>";

    customMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(16, 16),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });

    return customMarker;
  };

  return (
    <>
      {markerType === MAP_MARKER_TYPES["NORMAL"]
        ? points.map((point, i) => {
            return (
              <Marker
                key={"mapMarker-" + i}
                position={{
                  lat: point.lat,
                  lng: point.lng,
                }}
                icon={getMapMarker(point, markerType)}
                className="mapMarker"
              >
                <Tooltip
                  direction="right"
                  offset={[10, -2]}
                  permanent
                  className={"makerLabel"}
                >
                  <span>{point.name}</span>
                </Tooltip>
              </Marker>
            );
          })
        : showMarkers &&
          points.map((point, i) => {
            return (
              // radarData ?
              <Marker
                key={"mapMarker-" + i}
                position={{
                  lat: point.lat,
                  lng: point.lng,
                }}
                icon={getMapMarker(point, markerType)}
                className="mapMarker"
              >
                {showLabels && (
                  <Tooltip
                    direction="right"
                    offset={[10, -2]}
                    permanent
                    className={
                      markerType === MAP_MARKER_TYPES["SEVERE_DELAY"]
                        ? "makerLabel severeRed"
                        : markerType === MAP_MARKER_TYPES["REGULAR_DELAY"]
                        ? "makerLabel regularGreen"
                        : markerType === MAP_MARKER_TYPES["MODERATE_DELAY"]
                        ? " makerLabel moderateOrange"
                        : "makerLabel"
                    }
                  >
                    <span>{point.name}</span>
                  </Tooltip>
                )}
                {tripDelivery ? (
                  <Popup>
                    <div className="markerPopup">
                      <div>
                        <h4>
                          <span className="popupName">{point.areaName}</span>
                        </h4>
                        <p className="popupAddress">{point.enteredOn}</p>
                        <p className="popupAddress">{point.deliveryComments}</p>

                        {point.files.map((v, i) => {
                          return (
                            <img
                              src={`${API_CONFIG.STATIC_URL}${v.path}`}
                              alt="Image Description"
                              style={{ width: "maxContent", height: "100px" }}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </Popup>
                ) : showParking ? (
                  <Popup>
                    <div className="markerPopup">
                      <div>
                        <table>
                          <tbody>
                            <tr>
                              <td> {LABELS.CAME_AT}</td> <td>: &nbsp;</td>
                              <td>{point.cameAt}</td>
                            </tr>
                            <tr>
                              <td> {LABELS.LEFT_AT}</td> <td>:&nbsp;</td>
                              <td>{point.leftAt}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Popup>
                ) : (
                  <Popup>
                    <div className="markerPopup">
                      <table>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <h4>
                                <span className={"popupName"}>
                                  {point.name}
                                </span>
                                <span
                                  className={
                                    "tripStatus" + " " + point.tripStatus
                                  }
                                >
                                  {point.tripStatus}
                                </span>
                              </h4>
                              <p className="popupAddress">{point.address} </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3} className="bold">
                              <h3 style={{ margin: "0.1rem" }}>
                                {point.vehicleNumber}
                              </h3>
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.POSITION}</td>
                            <td>: &nbsp; &nbsp;</td>
                            <td className="w60p pB5">
                              <a
                                href={
                                  "//maps.google.com/maps?q=" +
                                  point.lat +
                                  "," +
                                  point.lng
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {point.lat.toFixed(6)}°, {point.lng.toFixed(6)}°
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.IMEI}</td>
                            <td>: &nbsp; &nbsp;</td>
                            <td>{point.imei}</td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.VEHICLE_TYPE} </td>
                            <td>: &nbsp; &nbsp;</td>
                            <td>{point.vehicleType}</td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.DRIVERS_NAME} </td>
                            <td>: &nbsp; &nbsp;</td>
                            <td>{point.driverName}</td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.DRIVER_NO} </td>
                            <td>: &nbsp; &nbsp;</td>
                            <td>{point.driverNumber}</td>
                          </tr>
                          <tr>
                            <td className="bold">{LABELS.TRIP_NO} </td>
                            <td>: &nbsp; &nbsp;</td>
                            <td>{point.tripNo}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Popup>
                )}
              </Marker>
            );
          })}
    </>
  );
};

export default MapMarkers;
